// Package imports:
import React, { useCallback, useEffect, useRef, useState } from 'react';

const DEFAULT_HERO_SRC = 'https://cdn.livemarketdata.com/Images/KeldanWatchMailImage.png';
const KELDAN_LOGO_SRC = 'https://cdn.livemarketdata.com/KeldanLogos/Keldan_logo.png';

// Natural width of the email layout
const EMAIL_WIDTH = 660; // 600px content + 30px padding each side

interface IKYCSettingsEmailPreviewProps {
    bannerSrc?: string;
}

const KYCSettingsEmailPreview: React.FC<IKYCSettingsEmailPreviewProps> = ({ bannerSrc }) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const [scale, setScale] = useState(1);
    const [contentHeight, setContentHeight] = useState(0);

    const updateScale = useCallback(() => {
        if (wrapperRef.current && contentRef.current) {
            const wrapperWidth = wrapperRef.current.offsetWidth;
            const newScale = Math.min(wrapperWidth / EMAIL_WIDTH, 1);
            setScale(newScale);
            setContentHeight(contentRef.current.offsetHeight);
        }
    }, []);

    useEffect(() => {
        updateScale();
        window.addEventListener('resize', updateScale);
        return () => window.removeEventListener('resize', updateScale);
    }, [updateScale]);

    // Recalculate when banner changes (image load may change height)
    useEffect(() => {
        const timer = setTimeout(updateScale, 100);
        return () => clearTimeout(timer);
    }, [bannerSrc, updateScale]);

    const heroSrc = bannerSrc || DEFAULT_HERO_SRC;

    return (
        <div
            className="kyc-settings__email-preview"
            ref={wrapperRef}
            style={{ height: contentHeight * scale }}
        >
            <div
                className="KCL_kyc-settings-email-preview"
                ref={contentRef}
                style={{ transform: `scale(${scale})` }}
            >
                <div className="email-preview__outer">
                    {/* Logo */}
                    <div className="email-preview__logo">
                        <img src={KELDAN_LOGO_SRC} alt="Keldan" />
                    </div>

                    {/* White content box */}
                    <div className="email-preview__content">
                        {/* Hero image */}
                        <div className="email-preview__hero">
                            <img
                                src={heroSrc}
                                alt="Borði tölvupósts"
                                onLoad={updateScale}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KYCSettingsEmailPreview;
